import router from '../router'
import adminUserService from '../service/adminUser'

const adminUser = JSON.parse(localStorage.getItem('adminUser'));
const state = adminUser
    ? {
        status: {
            loggedIn: true
        },
        adminUser, 
        activeTab:"points"
    }
    : {
        status: {},
        adminUser: null,
        activeTab : 'points'
    };


const actions = {
    login({commit}, { email, password }) {
        commit('loginRequest', { email });
        adminUserService.auth( email, password)
            .then(adminUser => {
                commit('loginSuccess', adminUser);
                router.push('/admin-user');
            }).catch(() => {
                commit('loginFailure')
            })
    },
    logout({ commit }) {
        localStorage.removeItem('adminUser')
        router.push('/login')
        commit('logout');
    },
};
const mutations = {
    loginRequest(state, adminUser) {
        state.status = { loggingIn: true };
        state.adminUser = adminUser;
    },
    loginSuccess(state, data) {
        state.status = { loggedIn: true };
        state.adminUser = {
            id: data.id,
            name: data.name,
            surname: data.surname,
        };
    },
    loginFailure(state) {
        state.status = {};
        state.adminUser = null;
    },
    logout(state) {
        state.status = {};
        state.adminUser = null;
    },
};
export default {
    namespaced: true,
    state,
    actions,
    mutations
};
